// The two places a CLIENT is offered a review outside the form itself: the "My account"
// booking list and the consultation's exit screen.
//
// Both are one-line offers, never explanations — the form at /avis carries the copy that
// explains anything (`marketplace/reviews.js`). The "already reviewed" line exists so a
// client who comes back does not re-open a link that will only tell them off.
export default {
  fr: {
    "portal.leaveReview": "Laisser un avis",
    "portal.reviewed": "Avis déposé",
    "consult.room.ended.leaveReview": "Laisser un avis sur cette consultation",
    "consult.room.ended.reviewed": "Merci, votre avis a bien été déposé.",
  },
  en: {
    "portal.leaveReview": "Leave a review",
    "portal.reviewed": "Review left",
    "consult.room.ended.leaveReview": "Leave a review of this consultation",
    "consult.room.ended.reviewed": "Thank you, your review has been left.",
  },
  es: {
    "portal.leaveReview": "Dejar una opinión",
    "portal.reviewed": "Opinión enviada",
    "consult.room.ended.leaveReview": "Dejar una opinión sobre esta consulta",
    "consult.room.ended.reviewed": "Gracias, su opinión se ha enviado.",
  },
};
